import { Link } from "react-router-dom";
import { FileText, KeyRound } from "lucide-react";
import { AdminShell } from "./AdminShell";

const AdminDashboard = () => {
    return (
        <AdminShell title="Admin Panel" backTo="/">
            <div>
                <h2 className="font-display font-bold text-xl text-blue-950 tracking-tight">
                    Admin Dashboard
                </h2>
                <p className="text-slate-500 text-sm mt-1">
                    Aap sirf do options mein manage kar sakte ho — results aur password.
                </p>
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Link
                    to="/admin/results"
                    data-testid="admin-tile-manage-results"
                    className="group rounded-2xl border-2 border-blue-200 bg-blue-50 hover:bg-blue-100 hover:border-blue-300 transition-colors p-6 flex items-start gap-4"
                >
                    <div className="h-12 w-12 rounded-xl bg-blue-600 text-white grid place-items-center shrink-0 shadow-md">
                        <FileText className="h-6 w-6" />
                    </div>
                    <div>
                        <div className="font-display font-bold text-blue-950 text-lg tracking-tight">
                            Manage Results
                        </div>
                        <p className="text-xs text-slate-600 mt-1 leading-relaxed">
                            Sabhi games ke aaj ke aur pichle results ek jagah edit karein.
                        </p>
                    </div>
                </Link>

                <Link
                    to="/admin/change-password"
                    data-testid="admin-tile-change-password"
                    className="group rounded-2xl border-2 border-emerald-200 bg-emerald-50 hover:bg-emerald-100 hover:border-emerald-300 transition-colors p-6 flex items-start gap-4"
                >
                    <div className="h-12 w-12 rounded-xl bg-emerald-600 text-white grid place-items-center shrink-0 shadow-md">
                        <KeyRound className="h-6 w-6" />
                    </div>
                    <div>
                        <div className="font-display font-bold text-blue-950 text-lg tracking-tight">
                            Change Password
                        </div>
                        <p className="text-xs text-slate-600 mt-1 leading-relaxed">
                            Admin login password securely update karein.
                        </p>
                    </div>
                </Link>
            </div>
        </AdminShell>
    );
};

export default AdminDashboard;
